import { api } from 'src/api/api';

export type ProcessRunFidcApiResponse = {
  data: string;
  processedAmount: number;
  foundAmount: number;
  notFoundAmount: number;
};

export type RunFidcHistoryApiResponse = {
  id: number;
  content: string;
  processedAt: string;
  columns: string;
  createdAt: string;
  updatedAt: string;
};

export const processRunFidcBySpreedSheet = async (
  tableData: string,
): Promise<ProcessRunFidcApiResponse> => {
  const { data } = await api.post<ProcessRunFidcApiResponse>(
    '/run-fidc',
    { data: tableData },
    {
      headers: {
        'Content-Type': 'text/plain',
      },
    },
  );
  return (
    data ?? {
      data: '',
      processedAmount: 0,
      foundAmount: 0,
      notFoundAmount: 0,
    }
  );
};

export const getRunFidcHistory = async () => {
  const { data } = await api.get<RunFidcHistoryApiResponse[]>(
    '/run-fidc-historico/find-by-user-id',
  );
  return data;
};
